module.exports = __webpack_public_path__ + "static/media/img.81078b64.png";